import { createI18n } from 'vue-i18n'
import axios from 'axios'

// Create an instance of vue-i18n for Vue 3
export const i18n = createI18n({
  locale: window.app.login.siteLanguageHrefLang,
  messages: {} // Initialize with an empty object
})

export function loadLanguageAsync() {
  const locale = window.app.login.siteLanguageHrefLang
  const url = window.app.login.translationsAssetsPath + `/${locale}.json`

  return axios.get(url).then(response => {
    // Set the locale message after fetching the JSON file
    i18n.global.setLocaleMessage(locale, response.data)
  })
}
